// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1BU05","visuallyhidden":"_1ACYY","hide-text":"Qqcwo","center":"CLYRt","noprint":"_30Dr8","root":"_27Zu0","showSearchButton":"_1Qvax","searchIconLabel":"_2ATfJ","formContainer":"_2Yt5T","searchFormOpened":"_2_dIe","form":"_3J1QZ","formSubmit":"_2gSWV","searchInput":"_2IomA","clearButton":"_1-mt0"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/Search.scss
 ** module id = 454
 ** module chunks = 0
 **/